import EN from "./en";

const index = {
  en: EN,
};

export default index;
